import { createSlice } from '@reduxjs/toolkit';

import { ECexBot, EDexBot } from 'types/bots';

import { PAIRS_CONNECTED_BOTS_SLICE } from './constants';

type IConnectedBots = Record<EDexBot | ECexBot, boolean>;

interface IPairsConnectedBotsSliceState {
  pairsConnectedBots: Record<number, IConnectedBots | undefined>;
}
const sliceInitialState: IPairsConnectedBotsSliceState = {
  pairsConnectedBots: {},
};

const pairsSlice = createSlice({
  name: PAIRS_CONNECTED_BOTS_SLICE,
  initialState: sliceInitialState as IPairsConnectedBotsSliceState,
  reducers: {
    setConnectedBots: (
      state,
      {
        payload: { pairId, connectedBots },
      }: { payload: { pairId: number; connectedBots: IConnectedBots | undefined } },
    ) => {
      state.pairsConnectedBots[pairId] = connectedBots;
    },
  },
});

export const { setConnectedBots } = pairsSlice.actions;

export default pairsSlice.reducer;
